"use strict";
/* eslint-disable prettier/prettier */
// Plain JSON Values
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseRefName = exports.isReference = exports.isExpression = void 0;
function isExpression(v) {
    var _a;
    return v && ((_a = v) === null || _a === void 0 ? void 0 : _a.$);
}
exports.isExpression = isExpression;
function isReference(v) {
    return v && typeof v.$ === 'string';
}
exports.isReference = isReference;
/**
 *
 * @param refPointer Ref pointer, for example `a.b[0].c`
 * @returns Base reference name, for example `a` for `a.b[0].c` pointer
 */
function baseRefName(refPointer) {
    return refPointer.split(/[\.\[]/)[0];
}
exports.baseRefName = baseRefName;
//# sourceMappingURL=types.js.map